<template>
  <section>
    <!-- Componentes externos  <v-img
          :aspect-ratio="16 / 9"
          :src="ruta_icono"
          contain
          gradient="to bottom , rgba(100,115,201,0.05), rgba(5,5,5,.65)"
        > -->
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-card :color="color" v-if="ruta_icono">
      <v-card-text class="p-0">
        <v-img
          :aspect-ratio="16 / 9"
          :src="ruta_icono"
          contain
     
        >
          <v-layout
            pa-2
            column
            fill-height
            class="lightbox black--text text-xs-center"
          >
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <div>
                <b>{{ titulo }}</b>
              </div>
              <b style="font-size:1.5em">{{
                this.detalle || this.detalle == 0 ? this.detalle : "-"
              }}</b>
            </v-flex>
          </v-layout>
        </v-img>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  props: ["color", "detalle", "titulo", "ruta_icono"],
  // Variables iniciales del componente
  data() {
    return {
      user: this.$storage.get("user"),
      loading: false
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("closeDialog", () => {});
  },
  // Métodos y funciones del componente
  methods: {},
  // Definición de componentes importados
  components: {}
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/CuadroDetalle.vue